import * as React from "react";
import { Platform } from "utils/website";
import { TFrontModule } from "services/page/app";
import { FrontMeta } from "services/pool/app";
import { TPlayground, TModule } from "services/page/admin";
import { ParseProductTagFromUrlResp } from "utils/playground/url";
import { getSymbolByCurreny } from "utils/currency";
import Constant from "utils/isomorphismConstant";
import { getSchemeUtils } from "utils/browser/litbapp";
import MobileHome from "./Mobile/index";
import PcHome from "./Pc/index";

export interface InitialProps {
	page: TPlayground;
	modules: TFrontModule[];
	cookies?: string;
	meta: FrontMeta;
	tagQuery: ParseProductTagFromUrlResp;
	frontModules: TModule[];
}
export interface RuntimeProps {
	countryCode3: string;
	countryCode2?: string;
	countryKey: string;
	languageCode: string;
	platform: Platform;
	customerId: string;
	currency: string;
	hostname: string;
	api: string;
	userAgent: string;
	href: string;
	search: string;
	cookies: { [key: string]: any };
	origin: string;
	isUat: boolean;
	customerCookies: string;
	isInApp: boolean;
	appKey: string;
	appSecret: string;
	sid: string;
	sessionKey: string;
	sessionZeusKey: string;
	multiLanImgKey: string;
	visit: string;
	fav: string;
	cust: string;
	isIOS: boolean;
	isAndroid: boolean;
}
export interface HomeProps extends InitialProps {
	runtime: RuntimeProps;
}
export default function Home(props: HomeProps) {
	const platform = props.runtime.platform;
	const { runtime } = props;

	let [country, lang, currency] = [
		runtime.countryCode3 || "",
		runtime.languageCode || "",
		runtime.currency || "",
	];
	Constant.platform = platform;
	Constant.priceGraph = getSymbolByCurreny(currency);
	Constant.country = country || "ARM";
	Constant.language = lang || "fr";
	Constant.currency = currency || "EUR";
	Constant.multiLanImgKey = runtime.multiLanImgKey;
	getSchemeUtils(runtime.isInApp);

	if (platform === Platform.WEB) {
		return <PcHome {...props} />;
	}
	return <MobileHome {...props} />;
}
